import { v4 as uuid } from 'uuid';
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      "default": function _default() {
        return "select-input-".concat(uuid());
      }
    },
    error: String,
    label: String,
    modelValue: [String, Number, Boolean]
  },
  emits: ['update:modelValue'],
  data: function data() {
    return {
      selected: this.modelValue
    };
  },
  watch: {
    selected: function selected(_selected) {
      this.$emit('update:modelValue', _selected);
    }
  },
  methods: {
    focus: function focus() {
      this.$refs.input.focus();
    },
    select: function select() {
      this.$refs.input.select();
    }
  }
};